/**
 * Números dos três níveis de bot (item 5.1). A árvore de comportamento é a mesma em todos os níveis: o nível
 * muda o tempo de reação, a pontaria e quais ramos da árvore o bot sabe usar.
 */
export const BOT_LEVELS = ["facil", "medio", "dificil"] as const;
export type BotLevel = (typeof BOT_LEVELS)[number];

export interface BotLevelParams {
  label: string;
  /** O bot decide de novo a cada tanto (ticks); entre uma decisão e outra, segue a anterior. */
  thinkTicks: number;
  /** Erro de mira ao voar até um ponto (m), sorteado a cada decisão. */
  aimError: number;
  /** Prevê onde a bola (ou a Faísca) vai estar, em segundos à frente. */
  leadSeconds: number;
  /** Começa a carregar o arremesso a esta distância do aro (m), e carrega esta fração do máximo. */
  shootDistance: number;
  chargeFraction: number;
  /** Sabe passar quando é pressionado. */
  passes: boolean;
  /** Os artilheiros se dividem (um pressiona, os outros se posicionam) em vez de todos irem na bola. */
  teamwork: boolean;
  /** Usa a habilidade da posição. */
  abilities: boolean;
  /** Evita faltas: não atropela no turbo e não fica parado na frente do próprio aro. */
  avoidsFouls: boolean;
  /** Vira para o alvo antes de rebater o Petardo. */
  aimsBat: boolean;
  /** Fôlego mínimo para usar o turbo (o fácil gasta tudo e fica sem). */
  turboStamina: number;
}

export const BOT_LEVEL_PARAMS: Record<BotLevel, BotLevelParams> = {
  facil: {
    label: "Fácil",
    thinkTicks: 10,
    aimError: 4,
    leadSeconds: 0,
    shootDistance: 36,
    chargeFraction: 0.3,
    passes: false,
    teamwork: false,
    abilities: false,
    avoidsFouls: false,
    aimsBat: false,
    turboStamina: 0.05,
  },
  medio: {
    label: "Médio",
    thinkTicks: 5,
    aimError: 1.8,
    leadSeconds: 0.25,
    shootDistance: 28,
    chargeFraction: 0.7,
    passes: true,
    teamwork: true,
    abilities: true,
    avoidsFouls: false,
    aimsBat: false,
    turboStamina: 0.35,
  },
  dificil: {
    label: "Difícil",
    thinkTicks: 2,
    aimError: 0.5,
    leadSeconds: 0.45,
    shootDistance: 24,
    chargeFraction: 1,
    passes: true,
    teamwork: true,
    abilities: true,
    avoidsFouls: true,
    aimsBat: true,
    turboStamina: 0.45,
  },
};
